<!-- <section class="page-banner-sec" style="background-image: url(assets/img/career-detail-page-banner.png);"> -->

    <section class="page-banner-sec" [style.backgroundImage]="'url('+currentOpening?.image+')'">
      <div class="container">
          <h1 class="page-banner-title">Career</h1>
      </div>
    </section>
  
    <section class="py-5">
       <div class="container">
        <div class="row">
            <div class="col"><h2 class="font-weight-bold mb-3">{{ currentOpening?.title}}</h2></div>
            <div class="col-12 col-md-auto">
                <ol class="breadcrumb my-2 hide-on-phone">
                    <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
                    <li class="breadcrumb-item"><a [routerLink]="['/career']">Career</a></li>
                    <li class="breadcrumb-item active" aria-current="page">{{ currentOpening?.title}}</li>
                  </ol>
            </div>
        </div>
           
            <p class="text-76">
               <span class="border-right pr-3"><i class="fa fa-briefcase mr-2 text-theme"></i> Post: {{ currentOpening?.post}}  </span>
               <span class="border-right px-3"><i class="fa fa-star mr-2 text-theme"></i> Experience: {{ currentOpening?.experience}} </span>
               <span class="pl-3"><i class="fa fa-map-marker mr-2 text-theme"></i> Location: {{ currentOpening?.location}}</span>
            </p>

            <b class="mb-2 d-block">Description :</b>
           <p class="text-76">
            {{ currentOpening?.description}}
           </p>
            <!-- <p class="text-76">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p> -->
       </div>
    </section>
    <section class="sec-we-are-seeking">
        <div class="container">
            <h4 class="font-weight-bold">We Are Seeking The Candidate Who Have The Ability:</h4>
            <ul class="we-are-seeking-list">
                <li *ngFor="let ability of currentOpening?.ability">{{ability}}</li>
                <!-- <li>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</li>
                <li>When an unknown printer took a galley of type and scrambled it to make a type specimen book.</li>
                <li>It has survived not only five centuries, but also the leap into electronic typesetting.</li>
                <li>remaining essentially unchanged.</li>
                <li>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently </li>
                <li>With desktopLorem Ipsum is simply dummy text of the printing and typesetting industry.</li> -->
            </ul>
        </div>
    </section>
    <section class="sec-kr">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="box-kr">
                        <h4 class="font-weight-bold">Key Responsbilities</h4>
                        <ul class="list-kr">
                            <li *ngFor="let responsiblity of currentOpening?.responsiblity">{{responsiblity}}</li>
                            <!-- <li>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</li>
                            <li>when an unknown printer took a galley of type and scrambled it to make a type specimen book.</li>
                            <li>It has survived not only five centuries.</li>
                            <li>Also the leap into electronic typesetting, remaining essentially unchanged.</li>
                            <li>It was popularised in the 1960s with the release of Letraset sheets containing </li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="box-kr">
                        <h4 class="font-weight-bold">Bonus Points:</h4>
                        <ul class="list-kr" >
                            <li *ngFor="let bonus of currentOpening?.bonus">{{bonus}}</li>
                            <!-- <li>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</li>
                            <li>when an unknown printer took a galley of type and scrambled it to make a type specimen book.</li>
                            <li>It has survived not only five centuries.</li>
                            <li>Also the leap into electronic typesetting, remaining essentially unchanged.</li>
                            <li>It was popularised in the 1960s with the release of Letraset sheets containing </li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="sec-we-offer-facilities pb-5">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="text-we-offer-facilities">
                        <h2 class="font-weight-bold">We Offer The Facilities And Perks:</h2>
                        <ol>
                            <li *ngFor="let facilityAndPerk of currentOpening?.facilityAndPerk">{{facilityAndPerk}}</li>
                            <!-- <li><span>2.</span>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</li>
                            <li><span>3.</span>when an unknown printer took a galley of type and scrambled it to make a type specimen book.</li>
                            <li><span>4.</span>It has survived not only five centuries.</li>
                            <li><span>5.</span>It has survived not only five centuries.</li> -->
                            </ol>
                        <div class="mt-4">
                            <button (click)="openVerticallyCentered(content)" class="btn btn-primary font-weight-bold">Apply Now</button>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="image-we-offer-facilities">
                        <img src="assets/img/we-offer-cd.png" class="img-responsive">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <ng-template #content let-modal>
        <div class="modal-header border-0 pb-0 px-lg-5">
          <h4 class="modal-title font-weight-bold">Apply Now</h4>
          <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button> -->
        </div>
        <div class="modal-body px-lg-5">
            <form class="form-w" >
                <div class="row" [formGroup]="applyJobForm" (ngSubmit)="submitApplyJobForm(formDirective)"  #formDirective="ngForm">
                    <div class="col-12 mt-2">

                        <div class="custom-tabs custom-tabs-100 appPreviewUl d-flex justify-content-start">
                            <span><label class="mt-2 pt-1 mr-3">I am a</label></span>
                            <ul class="justify-content-start nav nav-pills mb-4 shadow" style="justify-content: start !important;">
                              <li class="nav-item bg-white">
                                <a href="javascript:void(0);" (click)='genderSwitch(1)'  class="nav-link"  [class.active]="gender_Id==1">Male</a>
                              </li>
                              <li class="nav-item bg-white">
                                <a href="javascript:void(0);" (click)='genderSwitch(2)' class="nav-link" [class.active]="gender_Id==2">Female</a>
                              </li>
                            </ul>
                          </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" class="form-control" placeholder="Your Name" formControlName="name" 
                            [ngClass]="{ 'is-invalid': (submitted || f.name.touched && !f.name.valid) && f.name.errors }">
                            <div *ngIf="((submitted || f.name.touched) && f.name.errors)" class="invalid-feedback">
                              <div *ngIf="f.name.errors.required">Full Name is required</div>
                            </div>                        
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Email</label>
                            <input type="text" class="form-control" placeholder="Enter Email Address" formControlName="email"
                            [ngClass]="{ 'is-invalid': (submitted || f.email.touched && !f.email.valid)  && f.email.errors }" />
                            <div *ngIf="((submitted || f.email.touched) && f.email.errors)" class="invalid-feedback">
                                <div *ngIf="f.email.errors.required">Email is required</div>
                                <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Mobile</label>
                            <input type="text" class="form-control" appPhoneMask min="14" max="14" placeholder="Enter Mobile Number" formControlName="mobile"
                            [ngClass]="{ 'is-invalid': (submitted || f.mobile.touched && !f.mobile.valid) && f.mobile.errors }">
                            <div *ngIf="((submitted || f.mobile.touched) && f.mobile.errors)" class="invalid-feedback">
                                <div *ngIf="f.mobile.errors.required">Phone Number is required</div>
                                <div *ngIf="f.mobile.errors.minlength">Enter Minimum 10 digit Phone number</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group" style="position: relative;">
                            <label>Date Of Birth</label>
                            <input name="date" class="form-control" formControlName="dob" placeholder="Enter Date Of Birth"
                            [matDatepicker]="dobPicker" 
                            placeholder="MM/DD/YYYY"
                            max="{{todayDate}}"
                            [ngClass]="{ 'is-invalid': (submitted || f.dob.touched && !f.dob.valid) && f.dob.errors }">
                            <mat-datepicker-toggle  matSuffix [for]="dobPicker" style="position: absolute; top: 32px; right: 25px; outline: none; border: none;"></mat-datepicker-toggle>
                            <mat-datepicker #dobPicker ></mat-datepicker>
                            <div *ngIf="((submitted || f.dob.touched) && f.dob.errors)" class="invalid-feedback">
                                <div *ngIf="f.dob.errors.required">DOB is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Education</label>
                            <select class="form-control" formControlName="education"
                            [ngClass]="{ 'is-invalid': (submitted || f.education.touched && !f.education.valid) && f.education.errors }">
                                <option disabled>Select Education Qualification</option>
                                <option>Education 1</option>
                                <option>Education 2</option>
                            </select>
                            <div *ngIf="((submitted || f.education.touched) && f.education.errors)" class="invalid-feedback">
                                <div *ngIf="f.education.errors.required">Education is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Working In</label>
                            <input type="text" class="form-control" formControlName="workingIn" placeholder="Enter Current Company Name"
                            [ngClass]="{ 'is-invalid': (submitted || f.workingIn.touched && !f.workingIn.valid) && f.workingIn.errors }">
                            <div *ngIf="((submitted || f.workingIn.touched) && f.workingIn.errors)" class="invalid-feedback">
                                <div *ngIf="f.workingIn.errors.required">Working in is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group with-right--icon">
                            <!-- <input type="text" class="form-control" placeholder="Upload Your Resume"> -->
                            <i class="right--icon fa fa-paperclip" style="top: 18px;"></i>
                            <input type="file" (change)="onSelect($event)" placeholder="Upload Your Resume" class="form-control"
                            [ngClass]="{ 'is-invalid': (submitted || f.resume.touched && !f.resume.valid) && f.resume.errors }">
                            <div *ngIf="((submitted || f.resume.touched) && f.resume.errors)" class="invalid-feedback">
                                <div *ngIf="f.resume.errors.required">Resume is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <textarea class="form-control" formControlName="info" placeholder="Additional Information Here"></textarea>
                        </div>
                    </div>
                    <div class="mt-4">
                        <button (click)="submitApplyJobForm(formDirective)" class="btn btn-primary"  [disabled]="isLoadingData">
                                <span *ngIf="isLoadingData">
                                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </span>
                            Apply Now
                        </button>
                    </div>
                </div>

            </form>
        </div>
      </ng-template>
  
